import { render, staticRenderFns } from "./video-lightbox.vue?vue&type=template&id=0aedca45&"
import script from "./video-lightbox.vue?vue&type=script&lang=js&"
export * from "./video-lightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports